import axios from 'axios';
import authService from './authService';
import { fireUnauthorized } from './authEvents';
/**
 * Centralized Axios instance with auth header and basic 401 handling
 */

const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || 'http://localhost:8007';

/**
 * Get auth token from common storage keys
 * @returns {string|null}
 */
export function getAuthToken() {
  const keys = ['authToken', 'token', 'accessToken'];
  for (const k of keys) {
    const v = localStorage.getItem(k);
    if (v) return v;
  }
  return null;
}

const http = axios.create({
  baseURL: API_BASE_URL,
  timeout: 300000
});

// Attach Authorization header
http.interceptors.request.use(
  (config) => {
    const token = authService.getToken();
    if (token) {
      config.headers = config.headers || {};
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

http.interceptors.response.use(
  (response) => response,
  (error) => {
    const status = error?.response?.status;
    if (status === 401 || status === 403) {
      authService.removeToken();
      fireUnauthorized();
    }
    return Promise.reject(error);
  }
);

export default http;